import React, { Component } from 'react';
import ProgressiveBackgroundImage from '../progressiveImage';
import { Grid } from 'semantic-ui-react';
import Quote from './quote';

import styles from './quote.module.css';

class Testimonials extends Component {
    render() {
        const { base64: preview, originalImg: src } = this.props.bg.responsiveSizes;
        return (
            <ProgressiveBackgroundImage
                preview={preview}
                src={src}
                styles={{ minHeight: '10vh', textAlign: 'center', color: 'white' }}
            >

                <Grid doubling padded stackable centered columns={2} style={{ paddingTop: '30px' }}>
                    <Grid.Row>
                        <h2>What our customers are saying:</h2>
                    </Grid.Row>
                    <Grid.Row>
                        {this.props.quotes.edges.map(({ node }, index) => {
                            return (
                                <Grid.Column key={index}>
                                    <Quote name={node.user} testimony={node.testimony.testimony} />
                                </Grid.Column>
                            )
                        })}
                    </Grid.Row>
                </Grid>
            </ProgressiveBackgroundImage>
        );
    }
}

export default Testimonials;

// export const quoteQuery = graphql`
// query quoteQuery{
// testimonials:allContentfulTestimonials {
//   edges {
//     node {
//       user
//       testimony {
//         testimony
//       }
//     }
//   }
// }
// }`


// WEBPACK FOOTER //
// ./src/components/Testimonials/index.jsx